(function() {
'use strict';

angular
    .module('searchUnit')
    .directive('flightSearchUnit', flightSearchUnit);

function flightSearchUnit(searchUnitService, sharedSearchUnitService, occupancyService, preferences, dateUtil, $q) {
    // Configuration part, mandatory in every searchunit directive with delayed linker
    sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'flightSearchUnit');

    return {
        restrict: 'E',
        replace: true,
        scope: {
            moreOptions: '@',
            areaOverride: '@'
        },
        templateUrl: 'partials/searchunit/flight',
        controller: 'SharedSearchUnit',
        link(scope, el, attr, controller) {
            return sharedSearchUnitService.initializeArea(scope, el, attr, controller, 'flightSearchUnit');
        }
    };

    function _delayedLinker(scope, $element, attr, ssu) {
        scope.destinationAirportSelect = destinationAirportSelect;
        scope.destinationAirportDeselect = destinationAirportDeselect;
        scope.search = search;
        scope.getMultiSectorMinDate = getMultiSectorMinDate;
        scope.selectLegDate = selectLegDate;
        scope.selectLegAirport = selectLegAirport;
        scope.addLeg = addLeg;
        scope.rmLeg = rmLeg;
        scope.onSearchModeChange = onSearchModeChange;
        scope.onReturningToggle = onReturningToggle;
        scope.searchMode = searchUnitService.isOneWayFlightEnabled() ? 'oneway' : 'return';
        scope.onewayonly = searchUnitService.isOneWayFlightEnabled() || false;
        scope.isMultiSector = false;
        scope.isMultiReturning = true;
        scope.legs = [{
            DepartureDate: null,
            DepartureAirport: null,
            DestinationAirport: null,
            Cabin: TRPCONFIG.Domain.DefaultCabin
        }];

        scope.toggleOptions = () => {
            scope.expandedOptions = !scope.expandedOptions;
        };
        scope.airportSelect = items => {
            searchUnitService.setMultipleDepartureAirports(items);
            loadOutboundDates();
        };
        scope.airportDeselect = () => {
            searchUnitService.clearDepartureAirports();
        };

        if (scope.moreOptions === 'true') {
            scope.updateCabin = updateCabin;
            scope.cabins = searchUnitService.getCabinOptions();
        } else {
            searchUnitService.setDefaultCabin();
        }

        _restoreSearchCriteria();

        function loadOutboundDates() {
            function getRequest() {
                const DepartureAirportCodes = searchUnitService.getDepartureAirports();
                if (!DepartureAirportCodes || !DepartureAirportCodes.length) {
                    return null;
                }
                const destinationAirport = searchUnitService.getDestinationAirport();
                if (!destinationAirport || !destinationAirport.Code) {
                    return null;
                }
                const DestinationAirportCodes = destinationAirport.Code.split(',');
                if (!DestinationAirportCodes.length) {
                    return null;
                }
                return {
                    DepartureAirportCodes,
                    DestinationAirportCodes
                };
            }

            const request = getRequest();
            searchUnitService.loadOutboundDates(request).then(outboundDates => scope.enabledDates = outboundDates);
        }

        function destinationAirportSelect(item) {
            const availableResorts = searchUnitService.setDestinationAirport(item, false);
            loadOutboundDates();
            return availableResorts;
        }

        function destinationAirportDeselect() {
            const availableResorts = searchUnitService.setDestinationAirport(null, false);
            scope.enabledDates = {};
            return availableResorts;
        }

        function search() {
            ssu.lockScreen('SEARCHINGFLIGHTS');
            const flightSearch = {};
            mapSearchTerms(flightSearch);
            preferences.set('flightSearch', flightSearch);

            sharedSearchUnitService.search(
                undefined,
                ssu.showErrors,
                scope.isMultiSector
                    ? { multi: true, legs: scope.legs, areaOverride: scope.areaOverride }
                    : { onewayonly: scope.onewayonly, areaOverride: scope.areaOverride }
            );
        }

        function updateCabin(cabin) {
            searchUnitService.setCabin(cabin);
        }

        function getMultiSectorMinDate(legIndex) {
            return legIndex === 0
                ? dateUtil.todayPlus(1, 0, true)
                : dateUtil.addDays(scope.legs[legIndex - 1].DepartureDate, 1, true);
        }

        function selectLegDate(leg, date) {
            leg.DepartureDate = date;
        }

        function selectLegAirport(leg, airport, type) {
            leg[type] = airport;

            if (!scope.isMultiReturning) {
                return;
            }

            const i = scope.legs.indexOf(leg);

            if (i === 0 && scope.legs.length > 1 && type === 'DepartureAirport') {
                scope.legs[scope.legs.length - 1].DestinationAirport = airport;
            } else if (i > 0 && i === scope.legs.length - 1 && type === 'DestinationAirport') {
                scope.legs[0].DepartureAirport = airport;
            }
        }

        function addLeg() {
            const prevLeg = scope.legs[scope.legs.length - 1];

            if (scope.isMultiReturning && scope.legs.length > 1) {
                prevLeg.DestinationAirport = null;
            }

            scope.legs.push({
                DepartureDate: dateUtil.addDays(prevLeg.DepartureDate, 7, true),
                DepartureAirport: null,
                DestinationAirport: scope.isMultiReturning ? scope.legs[0].DepartureAirport : null,
                Cabin: prevLeg.Cabin
            });
        }

        function rmLeg(leg) {
            const { legs } = scope;
            const i = legs.indexOf(leg);
            legs.splice(i, 1);

            if (legs.length > 1 && scope.isMultiReturning) {
                if (i === 0) {
                    legs[0].DepartureAirport = legs[legs.length - 1].DestinationAirport;
                } else if (i === legs.length) {
                    legs[legs.length - 1].DestinationAirport = legs[0].DepartureAirport;
                }
            }
        }

        function onSearchModeChange() {
            scope.onewayonly = scope.searchMode === 'oneway';
            scope.isMultiSector = scope.searchMode === 'multisector';
        }

        function onReturningToggle() {
            if (scope.isMultiReturning && scope.legs.length > 1) {
                scope.legs[scope.legs.length - 1].DestinationAirport = scope.legs[0].DepartureAirport;
            }
            searchUnitService.setIsMultiReturning(scope.isMultiReturning);
        }

        function mapSearchTerms(target, source) {
            if (!target) {
                return;
            }
            if (!source) {
                source = {};
            }

            let selectedDepartureAirport = searchUnitService.getSelectedDepartureAirport();
            if (selectedDepartureAirport) {
                selectedDepartureAirport = [selectedDepartureAirport];
            } else {
                selectedDepartureAirport = searchUnitService.getDepartureAirports();
            }
            target.airports = searchUnitService.chooseSeachUnitModel(target.airports, source.airports, selectedDepartureAirport);
            target.destinationAirport = searchUnitService.chooseSeachUnitModel(target.destinationAirport, source.destinationAirport, searchUnitService.getDestinationAirport());
            target.startDate = searchUnitService.chooseSeachUnitModel(target.startDate, source.startDate, searchUnitService.startDate(searchUnitService.flight));
            target.endDate = searchUnitService.chooseSeachUnitModel(target.endDate, source.endDate, searchUnitService.endDate(searchUnitService.flight));
            const occupancy = target.occupancy || source.occupancy || occupancyService.getOccupancy();
            target.occupancy = [occupancy.reduce((a, b) => {
                return {
                    Adults: a.Adults + b.Adults,
                    ChildAges: a.ChildAges.concat(b.ChildAges)
                };
            })];
            target.cabin = target.cabin || source.cabin || searchUnitService.getCabin();
            target.onewayonly = _.isBoolean(source.onewayonly) ? source.onewayonly : scope.onewayonly;
            target.isMultiSector = searchUnitService.getIsMultiSector() || scope.isMultiSector;
            target.searchMode = target.isMultiSector ? 'multisector' : target.onewayonly ? 'oneway' : 'return';
            target.isMultiReturning = searchUnitService.getIsMultiReturning();
            target.legs = searchUnitService.getLegs() || scope.legs;

            target.airports && searchUnitService.setMultipleDepartureAirports(target.airports);
            target.destinationAirport && searchUnitService.setDestinationAirport(target.destinationAirport);
            target.startDate && searchUnitService.startDate(searchUnitService.flight, target.startDate);
            target.endDate && searchUnitService.endDate(searchUnitService.flight, target.endDate);
            target.occupancy && occupancyService.setOccupancy(target.occupancy);
            target.cabin && searchUnitService.setCabin(target.cabin < 0 ? 1 : target.cabin); /// -1 caused API to return unhandled exception
            searchUnitService.setIsMultiSector(scope.isMultiSector);
            searchUnitService.setLegs(target.legs);
        }

        function _restoreSearchCriteria() {
            const promise = TRPCONFIG.Domain.isAgentMode ? $q.when() : preferences.get('flightSearch');
            promise.then(flightSearch => {
                mapSearchTerms(scope, flightSearch);
            });

            // Airports may be changed by other multi search forms
            scope.$watch(
                () => searchUnitService.getSelectedDepartureAirport(),
                v => {
                    scope.airports = v;
                    scope.airportsCount = _getAirportsCount(v);
                }
            );
        }

        function _getAirportsCount(airports) {
            if (airports && airports.Code) {
                return airports.Code.split(',').length;
            }
            return 0;
        }
    }
}
})();
